import { useSession } from "../hooks";
import type { PendingMessage } from "../sync/store";
import { Avatar } from "./ui";
import { t } from "../i18n";

// Pending shows one's own messages on their way to the server.
export function Pending({ items }: { items: PendingMessage[] }) {
  const session = useSession();
  const me = session.store.getSnapshot().me;
  return (
    <>
      {items.map((p) => (
        <article key={p.clientMsgID} className={`message pending mine ${p.status}`}>
          <div className="gutter">{me && <Avatar id={me.id} name={me.display_name || me.handle} size={36} />}</div>
          <div className="message-body">
            <header>
              <strong className="author">{me ? session.name(me.id) : ""}</strong>
              {p.status === "failed" ? <span className="failed-note">{t("Not sent")}</span> : <span className="sending">{t("Sending…")}</span>}
            </header>
            <div className="text">{p.text}</div>
            {p.status === "failed" && (
              <span className="retry-actions">
                <button className="retry" onClick={() => session.engine.retry(p.clientMsgID)}>
                  {t("Retry")}
                </button>
                <button className="retry" onClick={() => session.engine.discard(p.clientMsgID)}>
                  {t("Delete")}
                </button>
              </span>
            )}
          </div>
        </article>
      ))}
    </>
  );
}
